import { Box, Table } from '@factorialco/deprecated-design-system'
import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import createComputed from 'modules/core/hooks/createComputed'
import useSearch from 'modules/core/hooks/useSearch'

import type Field from 'modules/custom_resources/store/models/customResources/Field'
import type Schema from 'modules/custom_resources/store/models/customResources/Schema'
import type Value from 'modules/custom_resources/store/models/customResources/Value'

import Options from '../_Options'
import TableBody from '../_TableBody'
import TableHeader from '../_TableHeader'

const useFilteredValues = createComputed((search, values) => {
  if (!values || isEmpty(search)) return values

  return values?.filter((value: Value) => value.matchCustomFieldValue(search))
})
interface Props {
  canManage: boolean
  canAddValues: boolean
  attachableId: number
  fields: Field[]
  schema: Schema
  values?: Value[]
}

const TableComponent = ({
  attachableId,
  fields,
  schema,
  values,
  canManage,
  canAddValues,
}: Props) => {
  const { search, onSearch } = useSearch()
  const filteredValues = useFilteredValues(search, values).get()

  const TableOptions = () => (
    <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" gap="s24" flexGrow>
      <Options
        attachableId={attachableId}
        schema={schema}
        search={search}
        onSearch={onSearch}
        canAddValues={canAddValues}
        canManage={canManage}
      />
    </Box>
  )

  return (
    <Box overflowX="scroll">
      <Table options={TableOptions} style={{ minWidth: '100%', width: 'min-content' }} autoLayout>
        <TableHeader fieldsLabels={fields.map((f) => f.attributes.label)} />
        <TableBody
          attachableId={attachableId}
          schema={schema}
          fields={fields}
          values={filteredValues}
        />
      </Table>
    </Box>
  )
}

export default observer(TableComponent)
